export function expandCodes(codeRanges) {
  return codeRanges.flatMap(codeRange => {
    if (!codeRange.includes('-')) {
      return [codeRange]
    }
    const start = codeRange.split('-')[0]
    const end = codeRange.split('-')[1]
    return Array.from(Array(end - start + 1).keys()).map(i => (parseInt(start) + i).toString())
  })
}